


























import {Component, Prop, Vue} from 'vue-property-decorator';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';

@Component({
  components: {}
})
export default class AlertDialog extends Vue implements DialogInstance {

  @Prop() width!: number;

  dialog: boolean = false;
  resolve: any = null;
  reject: any = null;
  messages: string[] = [];
  title: string = '';
  options: any = {
    color: 'primary',
    width: this.width,
    zIndex: 200
  };
  hideOverlay: boolean = false;

  get show() {
    return this.dialog;
  }

  set show(value) {
    this.dialog = value;
    if (!value) {
      this.agree();
    }
  }

  open(title: string, messages: string[], options?: any) {
    DIALOG_STACK_INSTANCE.registerDialog(this);
    this.dialog = true;
    this.title = title;
    this.messages = messages;
    this.options = Object.assign(this.options, options);
    return new Promise<string>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  agree() {
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
    this.resolve(true);
    this.dialog = false;
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

}
